import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./Broadcasthead.css";

const Broadcasthead = () => {
  return (
    <div className="Broadcasthead-container">
      <Row className="align-items-center Broadcasthead-row">
        <Col lg={6} md={12} className="Broadcasthead-image-container">
          <Image
            src="https://caas.athenahealth.com/sites/default/files/styles/webp_image_style/public/2024/01/Group-Form.webp?itok=Yp18P7T_"
            alt="Behavioral Health EHR"
            className="Broadcasthead-image"
          />
        </Col>
        <Col lg={6} md={12} className="Broadcasthead-text">
          <h6 className="Broadcasthead-subtitle">
            Broadcast Resources – PDF Library
          </h6>
          <h2 className="Broadcasthead-title">
            Explore Our Latest Broadcast Materials
          </h2>
          <p
            className="Broadcasthead-description"
            style={{
              fontFamily: "Helvetica",
            }}
          >
            Browse through the available PDFs below, and feel free to download
            or view them to stay updated with our most recent broadcasts and
            resources. If you need more information or assistance, don’t
            hesitate to contact us.
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default Broadcasthead;
